export const TAGS = {
  id: -1,
  text: '',
  isSystem: false,
  colour: ''
};